import type {
  LocalRegionsResponse,
  LocalRegionsQueryParams,
  LocalAccommodationMapResponse,
  DomesticInfoRequestBody,
  DomesticInfoResponse,
  PlaceGeo2addressParams,
  PlaceGeo2addressResponse,
  LocalSearchHeaderResponse,
  LocalSearchRequestBody,
  LocalSearchCountResponse,
  LocalSearchListResponse,
  RecommendationLocalAccommodationRequest,
  RecommendationLocalAccommodationResponse,
  RecommendationLocalLeisureRequest,
  RecommendationLocalLeisureResponse,
} from '@weberus/shared-types';

import { fetcher } from '@/app/_shared/utils/fetcher';

/** [V1] 국내숙소 지역 상권(region) 리스트 조회 */
export const fetchLocalRegions = async (params: LocalRegionsQueryParams) => {
  return fetcher<LocalRegionsResponse, LocalRegionsQueryParams>({
    method: 'GET',
    url: '/list/local-accommodation/regions',
    params,
  });
};

/** 국내 숙소 SRP/PLP 정보 조회 */
export const fetchLocalAccommodationInfo = async (args: DomesticInfoRequestBody) => {
  return fetcher<DomesticInfoResponse, DomesticInfoRequestBody>({
    method: 'POST',
    url: '/search-site/domestic/info',
    data: args,
  });
};

/** 위치기반 주소 조회 */
export const fetchGeo2Address = async (args: PlaceGeo2addressParams) => {
  return fetcher<PlaceGeo2addressResponse, PlaceGeo2addressParams>({
    method: 'GET',
    url: '/joy/place/geo2address',
    params: args,
  });
};

/* [V3] 국내숙소 PLP/SRP 헤더 영역 조회 */
export const fetchLocalSearchHeader = async (args: LocalSearchRequestBody, headers?: Headers) => {
  return fetcher<LocalSearchHeaderResponse, LocalSearchRequestBody>({
    method: 'POST',
    url: '/list/local-accommodation/v3/search/header',
    data: args,
    headers, // SSR 시에는 headers를 주입해야함
  });
};

/* [V3] 국내숙소 PLP/SRP 리스트 조회 */
export const fetchLocalSearch = async (args: LocalSearchRequestBody, headers?: Headers) => {
  return fetcher<LocalSearchListResponse, LocalSearchRequestBody>({
    url: '/list/local-accommodation/v3/search',
    method: 'POST',
    data: args,
    headers,
  });
};

/** [V3] 국내숙소 지도 조회 */
export const fetchLocalAccommodationMap = async (args: LocalSearchRequestBody) => {
  return fetcher<LocalAccommodationMapResponse, LocalSearchRequestBody>({
    method: 'POST',
    url: '/list/local-accommodation/v3/search/map-view',
    data: args,
  });
};

/*[V3] 국내숙소 PLP/SRP CTA 버튼 개수 조회 */
export const fetchLocalSearchCount = async (args: LocalSearchRequestBody) => {
  return fetcher<LocalSearchCountResponse, LocalSearchRequestBody>({
    method: 'POST',
    url: '/list/local-accommodation/v3/search/count',
    data: args,
  });
};

/* 국내숙소 추천 상품 조회 */
export const fetchRecommendationLocalAccommodation = async (args: RecommendationLocalAccommodationRequest) => {
  return fetcher<RecommendationLocalAccommodationResponse, RecommendationLocalAccommodationRequest>({
    method: 'POST',
    url: '/list/recommendation/v1/keyword/local-accommodation',
    data: args,
  });
};

/* 레저 추천 상품 조회 */
export const fetchRecommendationLocalLeisure = async (args: RecommendationLocalLeisureRequest) => {
  return fetcher<RecommendationLocalLeisureResponse, RecommendationLocalLeisureRequest>({
    method: 'POST',
    url: '/list/recommendation/v1/keyword/local-leisure',
    data: args,
  });
};
